var map = {
	"./ALNA.svg": "29a0",
	"./Amaris.svg": "3245",
	"./BABE.svg": "faac",
	"./BAHA.svg": "ed12",
	"./BRUN.svg": "fd7c",
	"./HO24.svg": "c59f",
	"./HOHL.svg": "99aa",
	"./HOLU.svg": "2aeb",
	"./ILBE.svg": "c2df",
	"./ILER.svg": "3e0e",
	"./LGED.svg": "e9b3",
	"./LIEB.svg": "5ca6",
	"./LIHE.svg": "cf5e",
	"./LOBE.svg": "583e",
	"./SAMB.svg": "670d2",
	"./SAMS.svg": "048c",
	"./SOCO.svg": "a615",
	"./SOMA.svg": "8ae9",
	"./SSIM.svg": "25f0",
	"./Tchi.svg": "34d3",
	"./VAHA.svg": "3492",
	"./VANM.svg": "2ea0",
	"./WEWI.svg": "64fa",
	"./WING.svg": "ae9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2211";